import React from 'react'
import styled from 'styled-components'

/**
 * 画面中央の大きなアイコン表示エリア
 */
const IconArea: React.FC<IconAreaProps> = (props) => {
  return (
    <React.Fragment>
      {props.icon && <StyledIconArea>{props.icon}</StyledIconArea>}
    </React.Fragment>
  )
}

export type IconAreaProps = {
  icon?: React.ReactNode
}

const StyledIconArea = styled.div`
  margin: 44px 0;
  text-align: center;
`

export default IconArea
